import React, { useEffect, useState } from "react";
import {
  color_theme,
  defaultLabelColors,
  getStatusColors,
  status_translations,
} from "../../utils/constants";
import CustomFooter from "../../UiComponent/CustomFooter";
import {
  Divider,
  Drawer,
  Grid,
  IconButton,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import NewHeader from "../../UiComponent/NewHeader";
import Loader from "../../UiComponent/Loader";
import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router-dom";
import { Box, useTheme } from "@mui/system";
import Tab from "@mui/material/Tab";
import moment from "moment";
import { currencyFormat, handleLocalize } from "../../utils/helper";
import apiServices from "../../services/RequestHandler";
import {
  HomeIcon,
  PointerIcon,
  RefrestIcon,
} from "../../assets/images/FrankIcons";
import { getDataFromLocalStorage } from "../../utils/LocalStore.util";

import { makeStyles } from "@mui/styles";
import DrawerAnnounceDetail from "./DrawerAnnounceDetail";
import DrawerJobDetail from "./DrawerJobDetail";
import AnnounceDetailTablet from "./AnnounceDetailTablet";
import JobDetailTablet from "./JobDetailTablet";
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import MobileResponsive from "../LandingPage/MobileResponsive";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: "20px 0px" }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
//
interface VerticalTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function VerticalTabPanel(props: VerticalTabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles(() => ({
  scrollableArea: {
    height: "600px", // Give the area a height to enable scrolling
    width: "100%",
    overflowY: "auto", // Enable vertical scrolling
    padding: "10px",

    /* Custom scrollbar for WebKit browsers */
    "&::-webkit-scrollbar": {
      width: "12px", // Width of the scrollbar
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ee6931", // Color of the scrollbar thumb
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f5f5f5", // Background of the scrollbar track
    },

    /* Custom scrollbar for Firefox */
    scrollbarWidth: "thin", // Thin scrollbar for Firefox
    scrollbarColor: "#ee6931 #f5f5f5", // Thumb and track colors for Firefox
  },
  scrollableAreaa: {
    // width: "100%",
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "1px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#C1C1C1",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      // backgroundColor: "#f5f5f5",
    },
    "&::-webkit-scrollbar-button": {
      display: "none", // 🔥 Hides the scrollbar arrows
    },

    scrollbarWidth: "thin",
    scrollbarColor: `#C1C1C1`,
  },
  scrollableAreaTab: {
    height: "600px", // Give the area a height to enable scrolling

    overflowY: "auto", // Enables vertical scrolling
    scrollbarWidth: "none", // Hides scrollbar in Firefox
    "-ms-overflow-style": "none", // Hides scrollbar in IE & Edge
    "&::-webkit-scrollbar": {
      display: "none", // Hides scrollbar in Chrome, Safari, Opera
    },
    "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
  },
}));

export default function MesActivity(props:any) {
  // const { classes } = props;
  const param = useParams();
  // eslint-disable-next-line
  const [params, setParams] = useState(param);

  const classes = useStyles();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      numbrOfjobResult: 5,
      numbrOfAnnouceResult: 5,
      job_drawer: false,
      announce_drawer: false,
    }
  );

  const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const screen_600 = useMediaQuery(theme.breakpoints.up(601));

  const [value, setValue] = React.useState(
    params?.tab_id ? Number(params?.tab_id) : 0
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // eslint-disable-next-line
  const [verticalTabValue, setVerticalTabValue] = React.useState(
    Number(getDataFromLocalStorage("tab_state")?.ver_tab ?? 0)
  );
  useEffect(() => {
    if (location?.state) {
      setValue(location?.state?.tab_id ?? 0);
      if (location?.state?.tab_id === 1) {
        setState({
          job_drawer: true,
          ann_id: location?.state?.ship_id,
        });
        // return;
      } else {
        setDrawerOpen(true);
        setState({
          ann_id: location?.state?.ship_id,
        });
        return;
      }
    }
  }, [location.state]);

  const handleGetAllDeliveries = async () => {
    try {
      let resp = await apiServices.getFromApi(
        "c2c-shipments/get-by-customer",
        ""
      );

      if (resp?.status === 200 || resp?.status === 201) {
        setState({
          deliveries: resp?.data,
          loadingLoader: false,
        });
      }
    } catch (error) {}
  };
  const handleGetAllJobs = async () => {
    try {
      let resp = await apiServices.getFromApi(
        "c2c-shipments/get-by-accepter",
        ""
      );

      if (resp?.status === 200 || resp?.status === 201) {
        setState({
          transporterJobs: resp?.data,
          loadingLoader: false,
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleGetAllDeliveries();
    handleGetAllJobs();
  }, []);
  //

  return (
    <>
      <Loader loading={state?.activity} />

      <Helmet>
        <title>Mes activity</title>
        <link rel="canonical" href="https://www.frank.fr/my-activity" />
          <link
          rel="icon"
          type="image/png"
          href="../../../public/frank_favicon.png"
        />
        <meta
          name="description"
          content="Découvrez nos articles et conseils sur la livraison collaborative, des témoignages de la communauté Frank, et des astuces pour optimiser vos envois."
        />
      </Helmet>
      <div
        className="web-screen"
        style={{ background: defaultLabelColors?.main_background_new }}
      >
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader />
            <div
              style={{
                background: defaultLabelColors?.main_background_new,
                padding: screen_1024 ? "80px 50px" : "80px 16px",
                marginTop: screen_1024 ? 80 : 30,
              }}
            >
              {(drawerOpen || state?.job_drawer) && !screen_1024 ? (
                <>
                  {drawerOpen && (
                    <div>
                      <AnnounceDetailTablet
                        classes={classes}
                        ann_id={state?.ann_id}
                        onClose={() => {
                          setDrawerOpen(false);
                          setState({ ann_id: "" });
                        }}
                      />
                    </div>
                  )}
                  {state?.job_drawer && (
                    <div>
                      <JobDetailTablet
                        classes={classes}
                        ann_id={state?.ann_id}
                        onClose={() =>
                          setState({ job_drawer: false, ann_id: "" })
                        }
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div>
                    <h1
                      style={{
                        fontFamily: "montserrat-Bold",
                        fontSize: screen_1024 ? "28px" : "20px",
                      }}
                    >
                      Mes activités
                    </h1>
                  </div>
                  <div>
                    <div style={{ borderBottom: "1px solid #E0E0E0" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        sx={{ width: "100%" }}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor:
                              defaultLabelColors?.main_orange_new,
                            color: defaultLabelColors?.main_orange_new,
                          },
                        }}
                      >
                        <Tab
                          label="Mes annonces"
                          {...a11yProps(0)}
                          sx={{
                            width: "50%",
                            maxWidth: "50% !important",
                            fontFamily: "montserrat-Medium !important",
                            fontSize: screen_1024
                              ? "18px !important"
                              : "16px !important",
                            textTransform: "none", // Disable uppercase
                            color: defaultLabelColors?.main_orange_new,

                            "&.Mui-selected": {
                              color: defaultLabelColors?.main_orange_new,
                              fontFamily: "montserrat-Bold !important",
                            },
                          }}
                        />
                        <Tab
                          label="Mes trajets"
                          {...a11yProps(1)}
                          sx={{
                            width: "50%",
                            maxWidth: "50% !important",

                            fontFamily: "montserrat-Medium !important",
                            fontSize: screen_1024
                              ? "18px !important"
                              : "16px !important",

                            color: defaultLabelColors?.main_orange_new,

                            textTransform: "none", // Disable uppercase
                            "&.Mui-selected": {
                              color: defaultLabelColors?.main_orange_new,
                              fontFamily: "montserrat-Bold !important",
                            },
                          }}
                        />
                      </Tabs>
                    </div>
                    <CustomTabPanel value={value} index={0}>
                      <div
                        style={{
                          background: color_theme.white,
                          borderRadius: 16,
                          padding: 0,
                        }}
                      >
                        <VerticalTabPanel value={verticalTabValue} index={0}>
                          <div
                            className={
                              screen_1024
                                ? classes?.scrollableArea
                                : classes?.scrollableAreaTab
                            }
                            id="scrolll_bar"
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                rowGap: 24,
                              }}
                            >
                              {state?.deliveries
                                ?.slice(0, state?.numbrOfAnnouceResult)
                                .map((i: any) => {
                                  return (
                                    <>
                                      {state?.deliveries.length < 1 ? (
                                        <div
                                          style={{
                                            marginTop: "5px",
                                            alignItems: "center",
                                            backgroundColor: " #fff",
                                            borderRadius: 12,
                                            fontFamily: "Raleway-Variable",
                                            cursor: "pointer",
                                            minHeight: "100px",
                                            border: "1px solid #D9D9D9",
                                            padding: 0,
                                          }}
                                        >
                                          <div>no announces</div>
                                        </div>
                                      ) : (
                                        <>
                                          <div id="main_heading">
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              {i?.shipment_items?.length > 1 ? (
                                                <div style={{ width: "80%" }}>
                                                  <h3
                                                    style={{
                                                      color: "#080626",
                                                      fontFamily:
                                                        "montserrat-Bold",
                                                      fontSize: 18,
                                                      marginLeft: 1,
                                                      display: "-webkit-box",
                                                      WebkitLineClamp: 1, // Ensures the text is limited to one line
                                                      lineClamp: 1, // Fallback for browsers that support it
                                                      WebkitBoxOrient:
                                                        "vertical",
                                                      maxWidth: "100%",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                      margin: 0,
                                                    }}
                                                  >
                                                    {i?.shipment_items
                                                      ?.length ?? 1}{" "}
                                                    articles :
                                                    <span
                                                      style={{
                                                        color: "#78778A",
                                                        fontFamily:
                                                          "montserrat-Regular",
                                                        fontSize: 12,
                                                        marginLeft: 1,
                                                      }}
                                                    >
                                                      {" "}
                                                      {i?.shipment_items
                                                        ?.map(
                                                          (item: any) =>
                                                            item.item_name_fr
                                                        )
                                                        .join(", ")}
                                                    </span>
                                                  </h3>
                                                </div>
                                              ) : (
                                                <h3
                                                  style={{
                                                    margin: 0,
                                                    color: "#080626",
                                                    fontFamily:
                                                      "montserrat-Bold",
                                                    fontSize: 18,
                                                  }}
                                                >
                                                  {handleLocalize({
                                                    fr: i?.shipment_items[0]
                                                      ?.item_name_fr,
                                                    en: i?.shipment_items[0]
                                                      ?.item_name_en,
                                                  }) ??
                                                    i?.shipment_items[0]
                                                      ?.prod_name ??
                                                    ""}{" "}
                                                </h3>
                                              )}
                                              <p
                                                style={{
                                                  margin: 0,
                                                  color:
                                                    defaultLabelColors?.main_orange_new,
                                                  fontSize: 18,
                                                  fontFamily: "montserrat-Bold",
                                                }}
                                              >{`${currencyFormat(
                                                i?.agree_ship_price
                                                  ? i?.agree_ship_price
                                                  : i?.ship_price
                                              )} €`}</p>
                                            </div>
                                            <div>
                                              <p
                                                style={{
                                                  margin: 0,
                                                  marginBottom: 5,
                                                  color: "#78778A",
                                                  fontSize: 12,
                                                  fontFamily:
                                                    "montserrat-Regular",
                                                }}
                                              >
                                                {`Publié le ${
                                                  i?.created_at
                                                    ? moment(
                                                        i.created_at
                                                      ).format(
                                                        "DD/MM/YYYY à HH[h]mm"
                                                      )
                                                    : ""
                                                }`}
                                              </p>
                                            </div>
                                            <div
                                              id="detail-div"
                                              style={{
                                                display: "flex",
                                                gap: 10,
                                              }}
                                            >
                                              <div
                                                id="img-div"
                                                style={{
                                                  display: !screen_600
                                                    ? "none"
                                                    : "block",

                                                  width: "30%",
                                                  maxWidth: "244px",
                                                }}
                                              >
                                                <Grid
                                                  container
                                                  spacing={0}
                                                  sx={{
                                                    height: "182px",

                                                    marginRight: "16px",
                                                  }}
                                                >
                                                  {i?.shipment_items?.map(
                                                    (
                                                      _items: any,
                                                      index: number
                                                    ) => {
                                                      if (index >= 4)
                                                        return null; // Don't render anything if index is greater than 5

                                                      return (
                                                        <Grid
                                                          item
                                                          md={
                                                            i?.shipment_items
                                                              ?.length === 1
                                                              ? 12
                                                              : i
                                                                  ?.shipment_items
                                                                  ?.length ===
                                                                  3 &&
                                                                index === 2
                                                              ? 12
                                                              : 6
                                                          }
                                                          xs={
                                                            i?.shipment_items
                                                              ?.length === 1
                                                              ? 12
                                                              : i
                                                                  ?.shipment_items
                                                                  ?.length ===
                                                                  3 &&
                                                                index === 2
                                                              ? 12
                                                              : 6
                                                          }
                                                          key={index}
                                                          sx={{
                                                            position:
                                                              "relative",
                                                            backgroundImage: `url("${encodeURI(
                                                              _items
                                                                .prod_images?.[0]
                                                            )}")`,
                                                            backgroundRepeat:
                                                              "no-repeat",
                                                            backgroundPosition:
                                                              "center",
                                                            backgroundSize:
                                                              "cover",
                                                            borderTopLeftRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : 0,
                                                            //
                                                            borderTopRightRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : 0,
                                                            //
                                                            borderBottomLeftRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 2
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 2
                                                                ? "16px"
                                                                : 0,
                                                            //
                                                            borderBottomRightRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 2
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 3
                                                                ? "16px"
                                                                : 0,
                                                          }}
                                                        >
                                                          {i?.shipment_items
                                                            ?.length > 4 &&
                                                          index === 3 ? (
                                                            <div
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                top: "50%",
                                                                left: "50%",
                                                                msTransform:
                                                                  "translate(-50%, -50%)", // For IE 9
                                                                transform:
                                                                  "translate(-50%, -50%)",
                                                              }}
                                                            >
                                                              <svg
                                                                width="34"
                                                                height="34"
                                                                viewBox="0 0 34 34"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                              >
                                                                <rect
                                                                  width="34"
                                                                  height="34"
                                                                  rx="17"
                                                                  fill="white"
                                                                />
                                                                <path
                                                                  d="M11.75 17H22.25"
                                                                  stroke="black"
                                                                  stroke-width="2"
                                                                  stroke-linecap="round"
                                                                  stroke-linejoin="round"
                                                                />
                                                                <path
                                                                  d="M17 11.75V22.25"
                                                                  stroke="black"
                                                                  stroke-width="2"
                                                                  stroke-linecap="round"
                                                                  stroke-linejoin="round"
                                                                />
                                                              </svg>
                                                            </div>
                                                          ) : null}
                                                        </Grid>
                                                      );
                                                    }
                                                  )}
                                                </Grid>
                                              </div>

                                              <div
                                                className="card-details"
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  background: "#F4F3F6",
                                                  borderRadius: 16,
                                                  padding: "16px 16px",
                                                  gap: 10,
                                                  cursor: "pointer",
                                                  width: "70%",
                                                }}
                                                onClick={() => {
                                                  setState({ ann_id: i?.id });
                                                  setTimeout(() => {
                                                    setDrawerOpen(true);
                                                  }, 500);
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent:
                                                      "space-around",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      width: "36px",
                                                      height: "36px",
                                                      borderRadius: "50%",
                                                      background: "#FFFFFF",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <HomeIcon
                                                      height={30}
                                                      color="#3026F1"
                                                    />
                                                  </div>

                                                  {/* Dashed Line */}
                                                  <div
                                                    style={{
                                                      width: "2px",
                                                      height: "65px",
                                                      borderLeft:
                                                        "2px dashed #BCBBC4",
                                                      margin: "auto",
                                                    }}
                                                  />
                                                  <div
                                                    style={{
                                                      width: "36px",
                                                      height: "36px",
                                                      borderRadius: "50%",
                                                      background: "#FFFFFF",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <PointerIcon
                                                      height={30}
                                                      color="#F15A24"
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  id="address-div"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    flexDirection: "column",
                                                    width: "100%",
                                                  }}
                                                >
                                                  <div
                                                    id="yess"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        style={{
                                                          color: "#0000000",
                                                          fontSize: 14,
                                                          fontFamily:
                                                            "montserrat-Regular",
                                                        }}
                                                      >
                                                        Adresse de ramassage
                                                      </div>
                                                      <div
                                                        style={{
                                                          color: "#0000000",
                                                          fontSize: screen_1024
                                                            ? 18
                                                            : 16,
                                                          fontFamily:
                                                            "montserrat-Medium",
                                                        }}
                                                      >{`${i?.pickup?.city} , ${i?.pickup?.country}`}</div>
                                                    </div>
                                                    <div
                                                      style={{
                                                        borderRadius: "8px",
                                                        padding: "2px 10px",
                                                        fontFamily:
                                                          "montserrat-SemiBold",
                                                        fontSize: 14,
                                                        background:
                                                          getStatusColors[
                                                            i?.ship_status
                                                          ]?.bg,
                                                        color:
                                                          getStatusColors[
                                                            i?.ship_status
                                                          ]?.txt,
                                                        height: "max-content",
                                                      }}
                                                    >
                                                      {i?.ship_status ===
                                                        "Accepted" &&
                                                      i?.payment_status ===
                                                        "Paid"
                                                        ? "Payée"
                                                        : handleLocalize(
                                                            status_translations[
                                                              i?.ship_status
                                                            ]
                                                          )}
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div
                                                      style={{
                                                        color: "#0000000",
                                                        fontSize: 14,
                                                        fontFamily:
                                                          "montserrat-Regular",
                                                      }}
                                                    >
                                                      Adresse de livraison
                                                    </div>
                                                    <div
                                                      style={{
                                                        color: "#0000000",
                                                        fontSize: screen_1024
                                                          ? 18
                                                          : 16,
                                                        fontFamily:
                                                          "montserrat-Medium",
                                                      }}
                                                    >
                                                      {`${
                                                        i?.dropoff?.city ??
                                                        "city"
                                                      } , ${
                                                        i?.dropoff?.country ??
                                                        "country"
                                                      }`}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className="display-flex"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {}}
                                                >
                                                  <IconButton
                                                    onClick={() => {
                                                      setState({
                                                        ann_id: i?.id,
                                                      });
                                                      setTimeout(() => {
                                                        setDrawerOpen(true);
                                                      }, 500);
                                                      // announce_drawer
                                                    }}
                                                  >
                                                    <svg
                                                      width="20"
                                                      height="20"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                      <path
                                                        d="M7.5 15L12.5 10L7.5 5"
                                                        stroke="black"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                      />
                                                    </svg>
                                                  </IconButton>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <Divider
                                            color="#E9E8EB"
                                            style={{}}
                                            sx={{
                                              "&::before, &::after": {
                                                color: "#E9E8EB",
                                              },
                                            }}
                                          ></Divider>
                                        </>
                                      )}
                                    </>
                                  );
                                })}
                              {state?.deliveries?.length < 6 ||
                              state?.deliveries?.length < 1 ? null : (
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "Raleway-Variable",
                                    color: defaultLabelColors.main_blue,
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 10,
                                    marginTop: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setState({
                                      numbrOfAnnouceResult:
                                        state?.numbrOfAnnouceResult + 5,
                                    });
                                  }}
                                >
                                  <RefrestIcon
                                    fill={defaultLabelColors.main_blue}
                                  />{" "}
                                  Charger plus de transactions
                                </div>
                              )}
                            </div>
                          </div>
                        </VerticalTabPanel>
                      </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <div
                        style={{
                          background: color_theme.white,
                          borderRadius: 16,
                          padding: 0,
                        }}
                      >
                        <VerticalTabPanel value={verticalTabValue} index={0}>
                          <div
                            className={
                              screen_1024
                                ? classes?.scrollableArea
                                : classes?.scrollableAreaTab
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                rowGap: 24,
                              }}
                            >
                              {state?.transporterJobs
                                ?.slice(0, state?.numbrOfAnnouceResult)
                                .map((i: any) => {
                                  return (
                                    <>
                                      {state?.transporterJobs?.length < 1 ? (
                                        <div
                                          style={{
                                            marginTop: "5px",
                                            alignItems: "center",
                                            backgroundColor: " #fff",
                                            borderRadius: 12,
                                            fontFamily: "Raleway-Variable",
                                            cursor: "pointer",
                                            minHeight: "100px",
                                            border: "1px solid #D9D9D9",
                                            padding: 0,
                                          }}
                                        >
                                          <div>no announces</div>
                                        </div>
                                      ) : (
                                        <>
                                          <div>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              {i?.shipment_items?.length > 1 ? (
                                                <div style={{ width: "80%" }}>
                                                  <h3
                                                    style={{
                                                      color: "#080626",
                                                      fontFamily:
                                                        "montserrat-Bold",
                                                      fontSize: 18,
                                                      marginLeft: 1,
                                                      display: "-webkit-box",
                                                      WebkitLineClamp: 1, // Ensures the text is limited to one line
                                                      lineClamp: 1, // Fallback for browsers that support it
                                                      WebkitBoxOrient:
                                                        "vertical",
                                                      maxWidth: "100%",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                      margin: 0,
                                                    }}
                                                  >
                                                    {i?.shipment_items
                                                      ?.length ?? 1}{" "}
                                                    articles :
                                                    <span
                                                      style={{
                                                        color: "#78778A",
                                                        fontFamily:
                                                          "montserrat-Regular",
                                                        fontSize: 12,
                                                        marginLeft: 1,
                                                      }}
                                                    >
                                                      {" "}
                                                      {i?.shipment_items
                                                        ?.map(
                                                          (item: any) =>
                                                            item.item_name_fr
                                                        )
                                                        .join(", ")}
                                                    </span>
                                                  </h3>
                                                </div>
                                              ) : (
                                                <h3
                                                  style={{
                                                    margin: 0,
                                                    color: "#080626",
                                                    fontFamily:
                                                      "montserrat-Bold",
                                                    fontSize: 18,
                                                  }}
                                                >
                                                  {handleLocalize({
                                                    fr: i?.shipment_items[0]
                                                      ?.item_name_fr,
                                                    en: i?.shipment_items[0]
                                                      ?.item_name_en,
                                                  }) ??
                                                    i?.shipment_items[0]
                                                      ?.prod_name ??
                                                    ""}{" "}
                                                </h3>
                                              )}
                                              <p
                                                style={{
                                                  margin: 0,
                                                  color:
                                                    defaultLabelColors?.main_orange_new,
                                                  fontSize: 18,
                                                  fontFamily: "montserrat-Bold",
                                                }}
                                              >{`${currencyFormat(
                                                i?.agree_ship_price
                                                  ? i?.agree_ship_price
                                                  : i?.ship_price
                                              )} €`}</p>
                                            </div>
                                            <div>
                                              <p
                                                style={{
                                                  margin: 0,
                                                  marginBottom: 5,
                                                  color: "#78778A",
                                                  fontSize: 12,
                                                  fontFamily:
                                                    "montserrat-Regular",
                                                }}
                                              >
                                                {`Publié le ${
                                                  i?.created_at
                                                    ? moment(
                                                        i.created_at
                                                      ).format(
                                                        "DD/MM/YYYY à HH[h]mm"
                                                      )
                                                    : ""
                                                }`}
                                              </p>
                                            </div>
                                            <div
                                              id="detail-div"
                                              style={{
                                                display: "flex",
                                                gap: 10,
                                              }}
                                            >
                                              <div
                                                id="img-div"
                                                style={{
                                                  display: !screen_600
                                                    ? "none"
                                                    : "block",

                                                  width: "30%",
                                                  maxWidth: "244px",
                                                }}
                                              >
                                                <Grid
                                                  container
                                                  spacing={0}
                                                  sx={{
                                                    height: "182px",

                                                    marginRight: "16px",
                                                  }}
                                                >
                                                  {i?.shipment_items?.map(
                                                    (
                                                      _items: any,
                                                      index: number
                                                    ) => {
                                                      if (index >= 4)
                                                        return null; // Don't render anything if index is greater than 5

                                                      return (
                                                        <Grid
                                                          item
                                                          md={
                                                            i?.shipment_items
                                                              ?.length === 1
                                                              ? 12
                                                              : i
                                                                  ?.shipment_items
                                                                  ?.length ===
                                                                  3 &&
                                                                index === 2
                                                              ? 12
                                                              : 6
                                                          }
                                                          xs={
                                                            i?.shipment_items
                                                              ?.length === 1
                                                              ? 12
                                                              : i
                                                                  ?.shipment_items
                                                                  ?.length ===
                                                                  3 &&
                                                                index === 2
                                                              ? 12
                                                              : 6
                                                          }
                                                          key={index}
                                                          sx={{
                                                            position:
                                                              "relative",
                                                            backgroundImage: `url("${encodeURI(
                                                              _items
                                                                .prod_images?.[0]
                                                            )}")`,
                                                            backgroundRepeat:
                                                              "no-repeat",
                                                            backgroundPosition:
                                                              "center",
                                                            backgroundSize:
                                                              "cover",
                                                            borderTopLeftRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : 0,
                                                            //
                                                            borderTopRightRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : 0,
                                                            //
                                                            borderBottomLeftRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 2
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 2
                                                                ? "16px"
                                                                : 0,
                                                            //
                                                            borderBottomRightRadius:
                                                              i?.shipment_items
                                                                ?.length ===
                                                                1 && index === 0
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    2 &&
                                                                  index === 1
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    3 &&
                                                                  index === 2
                                                                ? "16px"
                                                                : i
                                                                    ?.shipment_items
                                                                    ?.length ===
                                                                    4 &&
                                                                  index === 3
                                                                ? "16px"
                                                                : 0,
                                                          }}
                                                        >
                                                          {i?.shipment_items
                                                            ?.length > 4 &&
                                                          index === 3 ? (
                                                            <div
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                top: "50%",
                                                                left: "50%",
                                                                msTransform:
                                                                  "translate(-50%, -50%)", // For IE 9
                                                                transform:
                                                                  "translate(-50%, -50%)",
                                                              }}
                                                            >
                                                              <svg
                                                                width="34"
                                                                height="34"
                                                                viewBox="0 0 34 34"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                              >
                                                                <rect
                                                                  width="34"
                                                                  height="34"
                                                                  rx="17"
                                                                  fill="white"
                                                                />
                                                                <path
                                                                  d="M11.75 17H22.25"
                                                                  stroke="black"
                                                                  stroke-width="2"
                                                                  stroke-linecap="round"
                                                                  stroke-linejoin="round"
                                                                />
                                                                <path
                                                                  d="M17 11.75V22.25"
                                                                  stroke="black"
                                                                  stroke-width="2"
                                                                  stroke-linecap="round"
                                                                  stroke-linejoin="round"
                                                                />
                                                              </svg>
                                                            </div>
                                                          ) : null}
                                                        </Grid>
                                                      );
                                                    }
                                                  )}
                                                </Grid>
                                              </div>

                                              <div
                                                className="card-details"
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  background: "#F4F3F6",
                                                  borderRadius: 16,
                                                  padding: "16px 16px",
                                                  gap: 10,
                                                  cursor: "pointer",
                                                  width: "70%",
                                                }}
                                                onClick={() => {
                                                  setState({ ann_id: i?.id });
                                                  setTimeout(() => {
                                                    setState({
                                                      job_drawer: true,
                                                    });
                                                  }, 500);
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent:
                                                      "space-around",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      width: "36px",
                                                      height: "36px",
                                                      borderRadius: "50%",
                                                      background: "#FFFFFF",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <HomeIcon
                                                      height={30}
                                                      color="#3026F1"
                                                    />
                                                  </div>

                                                  {/* Dashed Line */}
                                                  <div
                                                    style={{
                                                      width: "2px",
                                                      height: "65px",
                                                      borderLeft:
                                                        "2px dashed #BCBBC4",
                                                      margin: "auto",
                                                    }}
                                                  />
                                                  <div
                                                    style={{
                                                      width: "36px",
                                                      height: "36px",
                                                      borderRadius: "50%",
                                                      background: "#FFFFFF",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <PointerIcon
                                                      height={30}
                                                      color="#F15A24"
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  id="address-div"
                                                  style={{
                                                    display: "flex",
                                                    // gap: 15,
                                                    justifyContent:
                                                      "space-between",
                                                    flexDirection: "column",
                                                    width: "100%",
                                                  }}
                                                >
                                                  <div
                                                    id="yess"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        style={{
                                                          color: "#0000000",
                                                          fontSize: 14,
                                                          fontFamily:
                                                            "montserrat-Regular",
                                                        }}
                                                      >
                                                        Adresse de ramassage
                                                      </div>
                                                      <div
                                                        style={{
                                                          color: "#0000000",
                                                          fontSize: screen_1024
                                                            ? 18
                                                            : 16,
                                                          fontFamily:
                                                            "montserrat-Medium",
                                                        }}
                                                      >{`${i?.pickup?.city} , ${i?.pickup?.country}`}</div>
                                                    </div>
                                                    <div
                                                      style={{
                                                        borderRadius: "8px",
                                                        padding: "2px 10px",
                                                        fontFamily:
                                                          "montserrat-SemiBold",
                                                        fontSize: 14,
                                                        background:
                                                          getStatusColors[
                                                            i?.ship_status
                                                          ]?.bg,
                                                        color:
                                                          getStatusColors[
                                                            i?.ship_status
                                                          ]?.txt,
                                                        height: "max-content",
                                                      }}
                                                    >
                                                      {i?.ship_status ===
                                                        "Accepted" &&
                                                      i?.payment_status ===
                                                        "Paid"
                                                        ? "Payée"
                                                        : handleLocalize(
                                                            status_translations[
                                                              i?.ship_status
                                                            ]
                                                          )}
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div
                                                      style={{
                                                        color: "#0000000",
                                                        fontSize: 14,
                                                        fontFamily:
                                                          "montserrat-Regular",
                                                      }}
                                                    >
                                                      Adresse de livraison
                                                    </div>
                                                    <div
                                                      style={{
                                                        color: "#0000000",
                                                        fontSize: screen_1024
                                                          ? 18
                                                          : 16,
                                                        fontFamily:
                                                          "montserrat-Medium",
                                                      }}
                                                    >
                                                      {`${
                                                        i?.dropoff?.city ??
                                                        "city"
                                                      } , ${
                                                        i?.dropoff?.country ??
                                                        "country"
                                                      }`}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className="display-flex"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {}}
                                                >
                                                  <IconButton
                                                  // onClick={() => {
                                                  //   setState({
                                                  //     ann_id: i?.id,
                                                  //   });
                                                  //   setTimeout(() => {
                                                  //     setDrawerOpen(true);
                                                  //   }, 500);
                                                  //   // announce_drawer
                                                  // }}
                                                  >
                                                    <svg
                                                      width="20"
                                                      height="20"
                                                      viewBox="0 0 20 20"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                      <path
                                                        d="M7.5 15L12.5 10L7.5 5"
                                                        stroke="black"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                      />
                                                    </svg>
                                                  </IconButton>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <Divider
                                            color="#E9E8EB"
                                            style={{}}
                                            sx={{
                                              "&::before, &::after": {
                                                color: "#E9E8EB",
                                              },
                                            }}
                                          ></Divider>
                                        </>
                                      )}
                                    </>
                                  );
                                })}
                              {state?.deliveries?.length < 6 ||
                              state?.deliveries?.length < 1 ? null : (
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "Raleway-Variable",
                                    color: defaultLabelColors.main_blue,
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    // padding: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 10,
                                    marginTop: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setState({
                                      numbrOfAnnouceResult:
                                        state?.numbrOfAnnouceResult + 5,
                                    });
                                  }}
                                >
                                  <RefrestIcon
                                    fill={defaultLabelColors.main_blue}
                                  />{" "}
                                  Charger plus de transactions
                                </div>
                              )}
                            </div>
                          </div>
                        </VerticalTabPanel>
                      </div>
                    </CustomTabPanel>
                  </div>
                </>
              )}

              {/* end */}
            </div>
          </div>
        </div>

        {screen_1024 ? (
          <div
            className="main-container"
            style={{
              background: defaultLabelColors?.main_background_new,
              zIndex: 1,
            }}
          >
            <CustomFooter />
          </div>
        ) : screen_600 ? (
          <CustomMobileFooter />
        ) : null}
      </div>

      <Drawer
        anchor="right"
        open={drawerOpen && screen_1024 ? true : false}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: 620, // Adjust width to match your design
            // padding: 2,
            borderRadius: "16px",
            // paddingRight: "5px",
            height: "98vh",
            margin: "10px 10px",
            overflowY: "auto", // Enables vertical scrolling
            scrollbarWidth: "none", // Hides scrollbar in Firefox
            "-ms-overflow-style": "none", // Hides scrollbar in IE & Edge
            "&::-webkit-scrollbar": {
              display: "none", // Hides scrollbar in Chrome, Safari, Opera
            },
            "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
          },
        }}
      >
        <Box
          sx={{
            width: 620,
            display: "flex",
            flexDirection: "column",
          }}
          role="presentation"
        >
          <div>
            <DrawerAnnounceDetail
              classes={classes}
              ann_id={state?.ann_id}
              onClose={() => {
                setDrawerOpen(false);
                setState({ ann_id: "" });
              }}
            />
          </div>
        </Box>
      </Drawer>

      <Drawer
        anchor="right"
        open={state?.job_drawer && screen_1024 ? true : false}
        onClose={() => setState({ job_drawer: false, ann_id: "" })}
        PaperProps={{
          sx: {
            width: 620, // Adjust width to match your design
            borderRadius: "16px",
            height: "98vh",
            margin: "10px 10px",
            overflowY: "auto", // Enables vertical scrolling
            scrollbarWidth: "none", // Hides scrollbar in Firefox
            "-ms-overflow-style": "none", // Hides scrollbar in IE & Edge
            "&::-webkit-scrollbar": {
              display: "none", // Hides scrollbar in Chrome, Safari, Opera
            },
            "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
          },
        }}
      >
        <Box
          sx={{
            width: 620,
            display: "flex",
            flexDirection: "column",
          }}
          role="presentation"
        >
          <div>
            <DrawerJobDetail
              classes={classes}
              ann_id={state?.ann_id}
              onClose={() => setState({ job_drawer: false, ann_id: "" })}
            />
          </div>
        </Box>
      </Drawer>

      <div className="mobile-screen">
        <MobileResponsive />
      </div>
    </>
  );
}
